import { AUTH_LOGOUT, AUTH_ERROR, AUTH_CHECK } from "react-admin";
import {
  clearAccessTokenFromCookies,
  getAccessTokenFromCookies,
} from "./cookies";

export default (type) => {
  switch (type) {
    case AUTH_CHECK: {
      const accessToken = getAccessTokenFromCookies();

      if (accessToken) {
        return Promise.resolve();
      }
      window.location.href = `${process.env.REACT_APP_FRONTEND_URL}`;
      return Promise.reject(new Error("AUTH_CHECK ERROR"));
    }
    case AUTH_LOGOUT: {
      clearAccessTokenFromCookies();
      window.location.href = `${process.env.REACT_APP_FRONTEND_URL}/login`;
      return Promise.resolve();
    }
    case AUTH_ERROR: {
      return Promise.resolve();
    }
    default:
      return Promise.resolve();
  }

  // return Promise.resolve(false);
};



// WEBPACK FOOTER //
// ./src/authProvider.js